































import { Component, Mixins } from "vue-property-decorator";
import { ContentService } from "@/service/content.service";
import { SorryNotAreaContent } from "@/models/content/sorry-not-area";
import CommonMixin from "@/mixins/common-mixins";
import { AppData} from "@/models/app-data"

@Component({
  components: {},
})
export default class SorryNotArea extends Mixins(CommonMixin) {
  content: SorryNotAreaContent = {} as SorryNotAreaContent;
  textDirection = "ltr";
  appData = {} as AppData;

  async mounted(): Promise<void> {
    const contentService = new ContentService(this.$route);
    this.content = await contentService.getSorryNotAreaContent();
    this.textDirection = contentService.TextDirection();

    this.appData = this.getAppData();
    if (this.appData != null && this.appData.workflowId != null) {
       await this.putWorkflowStep( this.appData.workflowId, "SorryNotArea") 
    }

    this.postNavigatedToParent();
  }
}
